var _style, _rect, _g, _feColorMatrix, _feBlend, _defs, _polygon, _g2, _defs2, _path, _feColorMatrix2, _feBlend2, _defs3, _polygon2, _g3, _g4, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaggleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 780 380",
    style: {
      enableBackground: "new 0 0 780 380"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#9DD7CC;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st4{clip-path:url(#SVGID_2_);}\n\t.st5{enable-background:new    ;}\n\t.st6{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n\t.st7{mask:url(#XMLID_18_);}\n\t.st8{clip-path:url(#XMLID_19_);fill:#FFFFFF;}\n\t.st9{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st10{clip-path:url(#SVGID_4_);}\n\t.st11{clip-path:url(#SVGID_4_);fill:#FFFFFF;}\n\t.st12{mask:url(#XMLID_25_);}\n\t.st13{fill:none;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-width:9;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_136_",
    x: -90,
    y: -33.7,
    className: "st0",
    width: 1770,
    height: 1280.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_263_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_24_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_320_",
    className: "st1",
    d: "M125.5,190.3c-1.5,2.1-3.7,3.1-6.5,1c-7.6-6-9.3-13.3-5.8-26.6c7.8-29.3,25.3-73.7,36-91.8 c1.7-2.9,3.9-3.1,5.4-0.8c3.7,5.6,4.1,12.5-2.2,27.4c-7.1,17.4-17.8,42.4-27.1,69.8c20.1-29.3,53.5-69.8,75.8-93.9 c1.5-1.5,3.7-2.1,5.4,0.2c4.3,5.6,5.4,10.4,0,25.1c-6.9,18.1-16,41.7-24.3,69.6c21.9-31.8,63.9-81.4,82.9-99.5 c2.6-2.3,4.8-1.9,5.2,0.8c1.3,6.8-1.5,15-12.6,28c-15.8,18.5-47.9,54-74.1,89.9c-1.7,2.3-3.7,3.3-6.5,1c-7.4-6-10-12.9-6.7-26.6 c3.5-14.3,10.8-35.5,18-53.6C169,132.8,143.9,164.3,125.5,190.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_317_",
    className: "st1",
    d: "M305.4,113.9c2-2.5,3.7-2.9,5.2-1.2c3.2,3.5,5,11.8-0.2,21.4c-4.8,8.7-15.6,23.1-20.8,33.4 c-5.4,10.8-5.6,19.1,1.7,18.7c8.9-0.4,20.8-13.5,28.4-26.8c1.1-1.7,2.6-1.9,3.5-0.2c0.9,1.7,0.9,6.6-1.9,12 c-5.6,10.6-19.3,21.2-31.2,20.6c-11.7-0.6-17.8-6.8-17.8-15.8c-6.9,7.9-16.7,15-27.1,15c-20.1,0-24.3-24.5-6.3-47.8 c17.5-22.8,34.7-31.4,45.5-31.4c9.3,0,13.6,6.4,13.2,13.9C300.4,121.1,303,117,305.4,113.9z M288.1,121.8 c-6.9-0.6-22.7,12-34.7,29.1c-11.5,16.6-14.3,33.6-5.8,33.8c8.9,0.2,20.1-12.1,31.2-29.1C292.4,134.4,294.4,122.4,288.1,121.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_313_",
    className: "st1",
    d: "M363.5,196.3c-11.9,25.8-27.3,56.5-44.8,62.7c-4.3,1.5-8.7,1-12.6-4.1 c-4.5-5.8-8.4-12.5-4.3-23.9c6.3-17.4,24.9-29.1,46.3-36.5c2.2-4.2,4.1-8.9,6.3-13.3c-6.3,5.6-13.9,9.6-21.9,9.6 c-19.9,0-23.8-24.1-6.3-47.3c16.9-22.4,34.4-31,45.5-31c8.7,0,13,6,12.8,12.7c2.6-3.9,5-7.3,7.1-10.6c1.7-2.7,3.9-2.9,5.4-1.2 c3.2,3.5,5,11.8-0.4,21.2c-6.5,11.6-20.1,34.9-29.2,53.6c18.2-8.1,30.1-18.7,38.8-28.9c1.3-1.5,3.2-1.5,3.7,0.4 c0.4,1.7-0.7,6-4.3,11.2C397,182.8,381.4,190.5,363.5,196.3z M310.4,248.2c2.8,3.7,19.9-16.4,34-45.7 C316.3,217.1,306.7,243.5,310.4,248.2z M374.9,122.4c-6.7-0.4-22.5,12-34.4,28.7c-11.7,16.6-14.1,33.6-5.4,33.8 c8.4,0.2,19.5-12,30.5-28.9C379.3,134.8,381.2,122.8,374.9,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_309_",
    className: "st1",
    d: "M450.3,196.3c-11.9,25.8-27.3,56.5-44.8,62.7c-4.3,1.5-8.7,1-12.6-4.1 c-4.5-5.8-8.4-12.5-4.3-23.9c6.3-17.4,24.9-29.1,46.3-36.5c2.2-4.2,4.1-8.9,6.3-13.3c-6.3,5.6-13.9,9.6-21.9,9.6 c-19.9,0-23.8-24.1-6.3-47.3c16.9-22.4,34.4-31,45.5-31c8.7,0,13,6,12.8,12.7c2.6-3.9,5-7.3,7.1-10.6c1.7-2.7,3.9-2.9,5.4-1.2 c3.2,3.5,5,11.8-0.4,21.2c-6.5,11.6-20.1,34.9-29.2,53.6c18.2-8.1,30.1-18.7,38.8-28.9c1.3-1.5,3.2-1.5,3.7,0.4 c0.4,1.7-0.7,6-4.3,11.2C483.9,182.8,468.3,190.5,450.3,196.3z M397.3,248.2c2.8,3.7,19.9-16.4,34-45.7 C403.1,217.1,393.6,243.5,397.3,248.2z M461.8,122.4c-6.7-0.4-22.5,12-34.4,28.7c-11.7,16.6-14.1,33.6-5.4,33.8 c8.4,0.2,19.5-12,30.5-28.9C466.1,134.8,468.1,122.8,461.8,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_303_",
    className: "st1",
    d: "M509.2,185.5c10.4,0.8,25.6-13.1,34-28c1.5-2.5,3.9-2.7,4.8,0c1.1,3.1,0.2,7.3-2.2,12 c-3,5.8-18.8,21.8-36.2,21.4c-14.9-0.4-23-9.6-18-30.5c8-33.6,32.7-68.5,54.8-88.9c3.2-3.1,6.3-3.5,9.3-1c6.3,5,7.6,12.2,5,21.2 c-6.7,23.7-31,46.9-50.2,58.1C501.9,168.7,499.5,184.7,509.2,185.5z M553.4,87.7c-2.8-1.5-18.8,19.9-33.8,44.6 c-1.9,3.1-3.7,6.2-5.2,9.3C544.1,120.1,556.2,89.3,553.4,87.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_300_",
    className: "st1",
    d: "M568.8,185.9c18,0.8,33.8-14.7,43.1-27.4c1.1-1.5,2.8-1.5,3.7,0.2c0.9,1.5,0.2,6.9-3.7,12 c-9.1,11.8-25.8,20.6-42.4,20.8c-27.5,0.4-37-23.7-23-48.6c14.1-24.9,36.2-34.9,47-29.3c5.4,2.9,9.3,5.8,12.8,10 c3.9,4.6,2.2,16.4-6.9,26.2c-10.6,11.6-25.1,16.6-40.3,5.6C552.1,173.1,557.3,185.3,568.8,185.9z M586.8,141.5 c6.9-8.1,11.7-18.1,8.7-20.3c-4.5-3.3-22.5,8.3-32.7,26.6c-0.6,1.2-1.3,2.3-1.7,3.3C571.6,157.1,580.5,148.8,586.8,141.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_262_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.6,262.8c8.7,10.2,21.2,7.8,31.4,1.2c1.6-1.1-0.7-2.2-1.9-1.4c-8.8,5.6-19.3,7.6-26.8-1.1 C301.3,260.5,298.6,261.7,299.6,262.8L299.6,262.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_261_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M305.8,274.9c4.3,2.8,8.4,4,13.2,1.7c1.2-0.6,0.1-2.3-1-1.7c-4.1,2-7.6,0.7-11.2-1.7 C305.7,272.4,304.7,274.2,305.8,274.9L305.8,274.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_260_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M290,225c-3.2,5.9-4.6,10.8-0.8,16.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M288.3,224.8c-3.2,6-4.4,11.6-0.7,17.6c0.8,1.4,4.3,0,3.3-1.6c-3.3-5.4-1.9-10.4,0.9-15.7 C292.7,223.4,289,223.4,288.3,224.8L288.3,224.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_259_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M278.2,230c-1.8,3.3-2.6,6.1-0.5,9.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M276.5,229.8c-1.9,3.5-2.5,6.8-0.4,10.4c0.8,1.3,4.2,0,3.3-1.5c-1.8-2.9-1-5.6,0.5-8.5 C280.8,228.4,277.2,228.5,276.5,229.8L276.5,229.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_23_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M386.1,263.9c8.7,10.2,21.2,7.8,31.4,1.2c1.6-1.1-0.7-2.2-1.9-1.4c-8.8,5.6-19.3,7.6-26.8-1.1 C387.9,261.6,385.1,262.8,386.1,263.9L386.1,263.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_22_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M392.3,275.9c4.3,2.8,8.4,4,13.2,1.7c1.2-0.6,0.1-2.3-1-1.7c-4.1,2-7.6,0.7-11.2-1.7 C392.2,273.5,391.2,275.2,392.3,275.9L392.3,275.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_21_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M376.6,226.1c-3.2,5.9-4.6,10.8-0.8,16.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M374.8,225.9c-3.2,6-4.4,11.6-0.7,17.6c0.8,1.4,4.3,0,3.3-1.6c-3.3-5.4-1.9-10.4,0.9-15.7 C379.2,224.5,375.6,224.5,374.8,225.9L374.8,225.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M364.7,231c-1.8,3.3-2.6,6.1-0.5,9.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M363,230.9c-1.9,3.5-2.5,6.8-0.4,10.4c0.8,1.3,4.2,0,3.3-1.5c-1.8-3-1-5.6,0.5-8.5 C367.4,229.5,363.7,229.6,363,230.9L363,230.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_164_",
    className: "st1",
    d: "M461.2,222c-1.9-2.1-2.9-4.8-2.9-8.2c0-3.4,1-6.1,2.9-8.2c1.9-2.1,4.5-3.1,7.6-3.1 c5.1,0,8.4,2.3,9.8,6.9h-3c-0.5-1.5-1.3-2.6-2.4-3.4c-1.2-0.8-2.6-1.2-4.3-1.2c-2.3,0-4.1,0.8-5.5,2.3c-1.4,1.6-2.1,3.8-2.1,6.7 c0,2.9,0.7,5.2,2.1,6.7c1.4,1.6,3.3,2.4,5.5,2.4c1.7,0,3.2-0.4,4.3-1.2c1.2-0.8,2-2,2.4-3.4h3c-0.7,2.1-1.9,3.7-3.5,5 c-1.6,1.3-3.7,1.9-6.3,1.9C465.7,225.1,463.2,224,461.2,222z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    className: "st1",
    d: "M492.9,225.1c-3.1,0-5.7-1-7.6-3.1c-2-2.1-2.9-4.8-2.9-8.2c0-3.4,1-6.1,3.1-8.2 c2.1-2.1,4.7-3.1,7.8-3.1s5.7,1,7.8,3.1c2.1,2.1,3.1,4.8,3.1,8.2c0,3.3-1.1,6.1-3.3,8.2C498.7,224,496,225.1,492.9,225.1z  M492.9,222.8c2.3,0,4.2-0.8,5.9-2.4c1.7-1.6,2.5-3.8,2.5-6.7c0-2.8-0.8-5-2.4-6.6c-1.6-1.6-3.5-2.4-5.8-2.4s-4.2,0.8-5.7,2.4 c-1.5,1.6-2.3,3.8-2.3,6.7s0.7,5.1,2.2,6.7C488.8,222,490.6,222.8,492.9,222.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_159_",
    className: "st1",
    d: "M511.6,202.8v3.6c1.5-2.6,3.9-4,7.2-4c1.7,0,3.3,0.4,4.7,1.2c1.4,0.8,2.4,2,3.1,3.6 c0.7-1.5,1.8-2.7,3.2-3.6c1.4-0.9,3-1.3,4.8-1.3c2.4,0,4.5,0.8,6.1,2.4c1.6,1.6,2.4,3.9,2.4,6.9v13h-2.8v-12.5 c0-2.4-0.6-4.2-1.7-5.5c-1.2-1.3-2.7-1.9-4.8-1.9c-2,0-3.6,0.6-4.8,1.9c-1.2,1.3-1.7,3.1-1.7,5.5v12.5h-2.8v-12.5 c0-2.4-0.6-4.2-1.7-5.5c-1.2-1.3-2.7-1.9-4.8-1.9c-2,0-3.6,0.6-4.8,1.9c-1.2,1.3-1.7,3.1-1.7,5.5v12.5h-2.8v-21.8H511.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_156_",
    className: "st1",
    d: "M560.2,202.4c3.1,0,5.6,1,7.6,3.1c2,2,3,4.7,3,8.1c0,3.3-1,6.1-3,8.3 c-2,2.2-4.5,3.2-7.6,3.2c-2,0-3.7-0.5-5.2-1.5c-1.5-1-2.6-2.2-3.3-3.7V235h-2.8v-32.2h2.8v4.8c0.7-1.5,1.8-2.8,3.3-3.7 C556.5,202.9,558.2,202.4,560.2,202.4z M559.8,222.7c2.2,0,4.2-0.8,5.7-2.5c1.6-1.7,2.4-3.9,2.4-6.6c0-2.7-0.8-4.8-2.4-6.4 c-1.6-1.6-3.5-2.4-5.7-2.4c-2.3,0-4.2,0.8-5.7,2.5c-1.6,1.6-2.4,3.8-2.4,6.5c0,2.7,0.8,4.8,2.4,6.5 C555.6,221.9,557.5,222.7,559.8,222.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_153_",
    className: "st1",
    d: "M577,221.8c-2-2.2-3-4.9-3-8.3c0-3.3,1-6,3-8.1c2-2,4.5-3.1,7.6-3.1c2,0,3.7,0.5,5.2,1.4 c1.5,1,2.6,2.2,3.3,3.7v-4.8h2.8v21.8H593v-4.8c-0.7,1.5-1.8,2.8-3.3,3.7c-1.5,1-3.2,1.5-5.2,1.5C581.5,225.1,579,224,577,221.8 z M590.7,220.2c1.6-1.6,2.4-3.8,2.4-6.5c0-2.7-0.8-4.8-2.4-6.5c-1.6-1.6-3.5-2.5-5.7-2.5c-2.2,0-4.1,0.8-5.7,2.4 c-1.6,1.6-2.4,3.7-2.4,6.4c0,2.7,0.8,4.9,2.4,6.6c1.6,1.7,3.5,2.5,5.7,2.5S589.1,221.9,590.7,220.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_151_",
    className: "st1",
    d: "M604.6,202.8v3.6c1.5-2.6,3.9-4,7.2-4c2.4,0,4.5,0.8,6.1,2.4c1.6,1.6,2.4,3.9,2.4,6.9v13 h-2.8v-12.5c0-2.4-0.6-4.2-1.7-5.5c-1.2-1.3-2.7-1.9-4.8-1.9c-2,0-3.6,0.6-4.8,1.9c-1.2,1.3-1.7,3.1-1.7,5.5v12.5h-2.8v-21.8 H604.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_149_",
    className: "st1",
    d: "M632.4,224.4l-8.7-21.5h3l7.2,18.6l7.2-18.6h2.8l-13,32h-2.8L632.4,224.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_16_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_274_",
    className: "st1",
    d: "M125.2,43h-6v14.5c0,1.1,0.2,1.9,0.6,2.3c0.4,0.4,1.2,0.7,2.3,0.7h3.1v2.2h-3.7 c-3.4,0-5.1-1.7-5.1-5.2V43h-3v-2.2h3v-5.5h2.8v5.5h6V43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_273_",
    className: "st1",
    d: "M131.8,33v11.3c1.5-2.6,3.9-4,7.2-4c2.4,0,4.5,0.8,6.1,2.4c1.6,1.6,2.4,3.9,2.4,6.9v13h-2.8 V50.1c0-2.4-0.6-4.2-1.7-5.5c-1.2-1.3-2.7-1.9-4.8-1.9c-2,0-3.6,0.6-4.8,1.9c-1.2,1.3-1.7,3.1-1.7,5.5v12.5H129V33H131.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_272_",
    className: "st1",
    d: "M162.5,63c-3.1,0-5.7-1-7.6-3.1c-1.9-2.1-2.9-4.8-2.9-8.2c0-3.4,1-6.1,3-8.2 c2-2.1,4.6-3.1,7.7-3.1c3.2,0,5.7,1,7.5,2.9c1.9,1.9,2.8,4.4,2.8,7.2c0,0.8-0.1,1.5-0.2,2.2h-18c0.1,2.5,0.9,4.5,2.3,5.9 c1.4,1.4,3.2,2.2,5.4,2.2c1.7,0,3.1-0.4,4.3-1.2c1.2-0.8,2-1.8,2.5-3h3c-0.7,1.9-1.9,3.4-3.5,4.6C167.1,62.4,165,63,162.5,63z  M170.1,50.5c0-2.4-0.7-4.3-2.2-5.7c-1.5-1.4-3.3-2.1-5.4-2.1c-2.1,0-3.9,0.7-5.4,2.1c-1.4,1.4-2.2,3.3-2.3,5.8H170.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 23,
    y: 78.1,
    width: 38.8,
    height: 57.9
  }, _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })), /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "source",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 78.1,
    width: 38.8,
    height: 57.9,
    id: "XMLID_18_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "23,85.6 41.7,78.1 61.8,127.1 43.1,134.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "42.4,135 62,127.2 40.5,74.7 20.9,82.6  "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.8,121.6c0,0-0.5-3.9-5.1-3c-4.6,0.9-7.4,4-6,7.3c1.4,3.3,3.2,3.5,7.9,1.3 C56.3,125,54.8,121.6,54.8,121.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M41,95.9c0,0-4.6,1.7-6.3-4.6c-1.6-6.3,1.7-5.4,3-4.9C39.1,86.9,41,95.9,41,95.9"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_31_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_13_",
    points: "23,85.6 41.7,78.1 61.8,127.1 43.1,134.6  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_13_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    className: "st8",
    d: "M42.9,135.7c-2-1.9-5.5-16.4-4.2-17.6c3.3-3.1,4.5-2.4,4-5.6c-0.6-4.2-0.9-8.4-4.2-10.7 c-3.3-2.3-9.1-3.4-8.5-11.8c0.6-8.4,11.2-9.2,12.2-4.2c1,5,1.8,8.7,2.6,8.7c0.5,0,2.5-0.6,2.9-0.5c0.7,0.3,0.9,4.8,0.5,5 c-1.2,0.5-1.5,0.4-2.6,0.7c-1.1,0.4,2.4,13.6,4.2,13.2c1.8-0.4,4.5-1.3,5.9,2.9c1.4,4.2,3.9,13.2,1.2,14.5 c-2.7,1.3-0.7,1.9-2.5,2.8C51.7,134.6,44,136.8,42.9,135.7"
  })))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 670.2,
    y: 74.1,
    width: 84.6,
    height: 132.9
  }, _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0",
    colorInterpolationFilters: "sRGB",
    result: "source"
  })), /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "source",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 670.2,
    y: 74.1,
    width: 84.6,
    height: 132.9,
    id: "XMLID_25_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_3_",
    points: "717.5,79.2 749.4,91.2 702,205.3 670.2,193.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "668.7,195 706.3,209.1 756.4,88.2 718.9,74  "
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M696.6,170.9c0.2-1.3,4.4-39.6,14.8-59c7.4-13.8,17-22.9,23.5-14.7c6.6,8.1-9.4,33.4-17.3,44.6 C709.3,153.6,696.1,174.1,696.6,170.9"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_26_",
    className: "st12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st2",
    d: "M685.7,206.6c-1.9,1.1-2.5-0.7-4.6-2.5c-2.5-2.2,1-9.9,1.7-12.4c2.7-9.6,3.5-19.6,5.7-29.3 c2.6-11.5,5.7-22.9,9.5-34.1c2-5.9,4.2-11.7,6.7-17.3c9.3-20.5,28.1-33.4,37.8-22.5c10.8,12.2-6.7,39.5-22.5,63.9 C704,177,685.7,206.6,685.7,206.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_27_",
    className: "st13",
    points: "716.1,74.1 754.8,86.6 702,205.3 670.2,193.4  "
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st14",
    d: "M49.8,129c0,0,85,217,324,219s312-150,312-150"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaggleLogo);
export default __webpack_public_path__ + "static/media/waggle-logo.153ed779fd1c154099c4a11956e99627.svg";
export { ForwardRef as ReactComponent };